import { makeAutoObservable } from "mobx";
import type { ApplicationModel } from "../types/application.model";

export class ApplicationStore {
  list: ApplicationModel[] = [];
  selectedApplication: ApplicationModel | undefined = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  setList(applicationList: ApplicationModel[]): void {
    this.list = applicationList;
  }

  setSelectedApplication(application: ApplicationModel | undefined): void {
    this.selectedApplication = application;
  }
}
